<!--- COMPONENTE UCTimePicker ->
<!-
Descripción del componente:
-----
- Incluye un input que muestra la hora actual y permite modificarla.
Eventos del componente:
-----------------------

Plantillas de Diseño:
-----------------------
- P1 -> Por Defecto selector incrustado en formulario.
- P2 -> Selector flotante.
-->
<template>
  <div class="main-time-picker">
    <!-- -****************- -->
    <!--     TEMPLATE P1 -->
    <!-- -****************- -->
    <div v-if="template === 'P1'">
      <!-- <div
        v-if="title !== ''"
        class="block-title"
      >
        {{ title }}
      </div> -->
      <div
        v-if="title"
        class="title-time-picker"
      >
        <span>{{ title }}</span>
      </div>
      <div
        v-if="showInput"
        class="list no-margin"
        :class="{ 'disabled-component': disabled }"
      >
        <ul>
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-input-wrap">
                  <input
                    :id="nameElementPicker"
                    type="text"
                    :value="valor"
                    :placeholder="$t('common.hour')"
                    readonly="readonly"
                  >
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="block block-strong no-padding no-margin margin-bottom">
        <div :id="nameContentElementPicker" />
      </div>
    </div>

    <!-- -****************- -->
    <!--     TEMPLATE P2 -->
    <!-- -****************- -->

    <div v-if="template === 'P2'">
      <!-- <f7-block-title v-if="title">
        {{ title }}
      </f7-block-title> -->
      <!-- <div
        v-if="title !== ''"
        class="block-title"
      >
        {{ title }}
      </div> -->
      <div
        v-if="title"
        class="title-time-picker"
      >
        <span>{{ title }}</span>
      </div>
      <div
        class="content-calendar-input"
        :class="{ 'disabled-component': disabled }"
      >
        <input
          :id="nameElementPicker"
          class="input-calendar"
          type="text"
          :value="valor"
          :placeholder="$t('common.hour')"
          readonly="readonly"
        >
        <div
          class="input-calendar-icon"
          @click="pickerInline.open()"
        >
          <img
            class="selectable input-calendar-icon__search"
            src="@/static/icons/ic_date_select.svg"
            width="20px"
            height="20px"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sleep } from '@/js/utils/sleep';
import { f7 } from 'framework7-vue';

export default {
  name: 'UCTimePicker',
  props: {
    id: { type: String, default: '1' },
    title: { type: String, default: '' },
    showInput: { type: Boolean, default: false },
    template: { type: String, default: 'P1' },
    dateTimeDefault: { type: Date, default: () => new Date() },
    disabled: { type: Boolean, default: false },
    showSeconds: { type: Boolean, default: false },
  },

  emits: ['onchange'],

  data() {
    return {
      pickerInline: null,
      nameContentElementPicker: 'gh-picker-time-content',
      nameElementPicker: 'gh-picker-hora-input',
      actualDateTime: null,
      seconds: null,
    };
  },
  computed: {
    valor: {
      get() {
        if (this.actualDateTime !== null) {
          if (this.seconds) {
            return `${this.actualDateTime.getHours()}:${this.actualDateTime.getMinutes() < 10 ? `0${this.actualDateTime.getMinutes()}` : this.actualDateTime.getMinutes()}:${this.actualDateTime.getSeconds()}`;
          }
          return `${this.actualDateTime.getHours()}:${this.actualDateTime.getMinutes() < 10 ? `0${this.actualDateTime.getMinutes()}` : this.actualDateTime.getMinutes()}`;
        }
        return null;
      },
      set(newValue) {
        this.actualDateTime = newValue;
      },
    },
  },

  mounted() {
    this.StartComponent();
  },
  methods: {
    StartComponent() {
      this.actualDateTime = this.dateTimeDefault;
      if (this.id == null || this.id === undefined) {
        this.nameContentElementPicker += 1;
        this.nameElementPicker += 1;
      } else {
        this.nameContentElementPicker += this.id;
        this.nameElementPicker += this.id;
      }
      this.seconds = this.actualDateTime?.getSeconds();
      if ((this.template == null || this.template === undefined || this.template === 'P1')) {
        if (this.showSeconds) {
          this.StartComponentTemplateP1Seconds();
        } else {
          this.StartComponentTemplateP1();
        }
      }
      if (this.template === 'P2') {
        if (this.showSeconds) {
          this.StartComponentTemplateP2Seconds();
        } else {
          this.StartComponentTemplateP2();
        }
      }
    },

    /**
     * Resets the time picker to the current time.
     * @public
     * @returns {void}
     */
    ResetToCurrentTime() {
      this.actualDateTime = new Date();

      const ahora = new Date();
      this.valor = new Date();
      this.ChangeTime(ahora.getHours(), ahora.getMinutes());
    },

    /**
     * Resets the time picker to the null value.
     * @public
     * @returns {void}
     */
    ResetToNullValue() {
      this.actualDateTime = null;
      this.valor = null;
      this.$emit('onchange', null);
    },

    /**
     * @public
     * @param {Date} time - The time to set.
     * @returns {void}
     */
    SetTime(time) {
      this.actualDateTime = time;
      this.seconds = this.actualDateTime.getSeconds();
      if ((this.template == null || this.template === undefined || this.template === 'P1')) {
        if (this.showSeconds) {
          this.StartComponentTemplateP1Seconds();
        } else {
          this.StartComponentTemplateP1();
        }
      }
      if (this.template === 'P2') {
        if (this.showSeconds) {
          this.StartComponentTemplateP2Seconds();
        } else {
          this.StartComponentTemplateP2();
        }
      }
    },

    ChangeTime(hours, minut) {
      const hhmm = `${hours}:${minut}`;
      this.$emit('onchange', hhmm);
    },

    ChangeTimeSecond(hours, minut, second) {
      const hhmm = `${hours}:${minut}:${second}`;
      this.$emit('onchange', hhmm);
    },

    StartComponentTemplateP1() {
      const self = this;
      // const today = new Date();
      // Evita que se genere
      // el picker-date antes que el DOM este cargado con los elementos XXXXXx y YYYYYY
      sleep(100).then(() => {
        this.pickerInline = f7.picker.create({
          containerEl: `#${self.nameContentElementPicker}`,
          inputEl: `#${self.nameElementPicker}`,
          toolbar: false,
          rotateEffect: true,
          value: (this.actualDateTime != null) ? [
            this.actualDateTime.getHours(),
            this.actualDateTime.getMinutes() < 10 ? `0${this.actualDateTime.getMinutes()}` : this.actualDateTime.getMinutes(),
          ] : null,
          formatValue(values) {
            return `${values[0]}:${values[1]}`;
          },
          cols: [
            // Hours
            {
              values: (function f() {
                const arr = [];
                for (let i = 0; i <= 23; i += 1) {
                  arr.push(i);
                }
                return arr;
              }()),
            },
            // Divider
            {
              divider: true,
              content: ':',
            },
            // Minutes
            {
              values: (function f() {
                const arr = [];
                for (let i = 0; i <= 59; i += 1) {
                  arr.push(i < 10 ? `0${i}` : i);
                }
                return arr;
              }()),
            },
          ],
          on: {
            change(picker, values) {
              self.ChangeTime(values[0], values[1]);
            },
          },
        });
      });
    },
    /** PLANTILLA P2 */

    StartComponentTemplateP2() {
      const self = this;
      // const today = new Date();
      // Evita que se genere el picker-date
      // antes que el DOM este cargado con los elementos XXXXXx y YYYYYY
      sleep(100).then(() => {
        this.pickerInline = f7.picker.create({
          inputEl: `#${self.nameElementPicker}`,
          toolbar: false,
          rotateEffect: true,
          openIn: 'popover',
          value: (this.actualDateTime != null) ? [
            this.actualDateTime.getHours(),
            this.actualDateTime.getMinutes() < 10 ? `0${this.actualDateTime.getMinutes()}` : this.actualDateTime.getMinutes(),
          ] : null,
          formatValue(values) {
            return `${values[0]}:${values[1]}`;
          },
          cols: [
            // Hours
            {
              values: (function f() {
                const arr = [];
                for (let i = 0; i <= 23; i += 1) {
                  arr.push(i);
                }
                return arr;
              }()),
            },
            // Divider
            {
              divider: true,
              content: ':',
            },
            // Minutes
            {
              values: (function f() {
                const arr = [];
                for (let i = 0; i <= 59; i += 1) {
                  arr.push(i < 10 ? `0${i}` : i);
                }
                return arr;
              }()),
            },
          ],
          on: {
            change(picker, values) {
              self.ChangeTime(values[0], values[1]);
            },
          },
        });
      });
    },

    StartComponentTemplateP1Seconds() {
      const self = this;
      // const today = new Date();
      // Evita que se genere
      // el picker-date antes que el DOM este cargado con los elementos XXXXXx y YYYYYY
      sleep(100).then(() => {
        this.pickerInline = f7.picker.create({
          containerEl: `#${self.nameContentElementPicker}`,
          inputEl: `#${self.nameElementPicker}`,
          toolbar: false,
          rotateEffect: true,
          value: (this.actualDateTime != null) ? [
            this.actualDateTime.getHours(),
            this.actualDateTime.getMinutes() < 10 ? `0${this.actualDateTime.getMinutes()}` : this.actualDateTime.getMinutes(),
            this.actualDateTime.getSeconds() < 10 ? `0${this.actualDateTime.getSeconds()}` : this.actualDateTime.getSeconds(),
          ] : null,
          formatValue(values) {
            return `${values[0]}:${values[1]}:${values[2]}`;
          },
          cols: [
            // Hours
            {
              values: (function f() {
                const arr = [];
                for (let i = 0; i <= 23; i += 1) {
                  arr.push(i);
                }
                return arr;
              }()),
            },
            // Divider
            {
              divider: true,
              content: ':',
            },
            // Minutes
            {
              values: (function f() {
                const arr = [];
                for (let i = 0; i <= 59; i += 1) {
                  arr.push(i < 10 ? `0${i}` : i);
                }
                return arr;
              }()),
            },
            // Divider
            {
              divider: true,
              content: ':',
            },
            // seconds
            {
              values: (function f() {
                const arr = [];
                for (let i = 0; i <= 59; i += 1) {
                  arr.push(i < 10 ? `0${i}` : i);
                }
                return arr;
              }()),
            },
          ],
          on: {
            change(picker, values) {
              self.ChangeTimeSecond(values[0], values[1], values[2]);
            },
          },
        });
      });
    },
    /** PLANTILLA P2 segundos */

    StartComponentTemplateP2Seconds() {
      const self = this;
      // const today = new Date();
      // Evita que se genere el picker-date
      // antes que el DOM este cargado con los elementos XXXXXx y YYYYYY
      sleep(100).then(() => {
        this.pickerInline = f7.picker.create({
          inputEl: `#${self.nameElementPicker}`,
          toolbar: false,
          rotateEffect: true,
          openIn: 'popover',
          value: (this.actualDateTime != null) ? [
            this.actualDateTime.getHours(),
            this.actualDateTime.getMinutes() < 10 ? `0${this.actualDateTime.getMinutes()}` : this.actualDateTime.getMinutes(),
            this.actualDateTime.getSeconds() < 10 ? `0${this.actualDateTime.getSeconds()}` : this.actualDateTime.getSeconds(),
          ] : null,
          formatValue(values) {
            return `${values[0]}:${values[1]}:${values[2]}`;
          },
          cols: [
            // Hours
            {
              values: (function f() {
                const arr = [];
                for (let i = 0; i <= 23; i += 1) {
                  arr.push(i);
                }
                return arr;
              }()),
            },
            // Divider
            {
              divider: true,
              content: ':',
            },
            // Minutes
            {
              values: (function f() {
                const arr = [];
                for (let i = 0; i <= 59; i += 1) {
                  arr.push(i < 10 ? `0${i}` : i);
                }
                return arr;
              }()),
            },
            // Divider
            {
              divider: true,
              content: ':',
            },
            // seconds
            {
              values: (function f() {
                const arr = [];
                for (let i = 0; i <= 59; i += 1) {
                  arr.push(i < 10 ? `0${i}` : i);
                }
                return arr;
              }()),
            },
          ],
          on: {
            change(picker, values) {
              self.ChangeTimeSecond(values[0], values[1], values[2]);
            },
          },
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.main-time-picker {
  --f7-block-margin-vertical: 15px;
  --f7-block-padding-horizontal: 16px;
}

.title-time-picker {
  font-size: var(--date-picker-label-font-size);
  color: var(--date-picker-label-color);
  line-height: var(--date-picker-label-line-height);
  margin: var(--date-picker-label-margin);
}

.content-calendar-input {
  display: flex;
  flex-direction: row;
  background-color: var(--date-picker-input-bg-color);
  border-radius: var(--date-picker-input-border-radius);
  border: var(--date-picker-input-border);
  box-sizing: border-box;

  input {
    height: var(--date-picker-input-height);
    color: var(--date-picker-input-color);
    font-size: var(--date-picker-input-font-size);
    font-weight: var(--date-picker-input-font-weight);
    padding: var(--date-picker-input-padding);
  }

  .input-calendar {
    width: calc(100% - 30px);
  }

  .input-calendar-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    box-sizing: border-box;
    min-width: var(--date-picker-btn-min-width);
    border-left: var(--date-picker-btn-border-left);
    background: var(--date-picker-btn-bg-color);
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;

    &__search {
      width: var(--date-picker-btn-search-img-size);
      height: var(--date-picker-btn-search-img-size);
    }
  }
}

.disabled-component {
  opacity: 0.6;
  pointer-events: none;
}
</style>
